import React, { useState, useEffect } from "react";
import Layout from "components/layout/Layout";
import localization from "assets/localization/localization";
import { BaseUrl } from "context/baseUrl/baseUrl";
import beautify from "json-beautify";
import "./applicationDetails.scss";
import MainLayout from "components/mainLayout/MainLayout";
import Table from "react-bootstrap/Table";
import { trim, uniq } from "lodash";
import Loader from "components/loader/loader";
import FormAccordion from "components/accordion/FormAccordion";
import { dateParser } from "services/utils/commonFunctions/CommonFunctions";
import CustomModal from "components/modal/modal";
import ConstVar from "constants/const";
import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import Images from "assets/images/imageData";
import CopyPaste from "components/copypaste/Copypaste";
import FormSection from "components/form/FormSection";
import DropDownFilter from "components/input/dropdown/dropDownFilter";
import JsonFormatter from "react-json-formatter";

const ApplicationDetails = ({
  match,
  // viewApplicantDetails,
  // history,
  // applicantDetailsData = [],
  // viewComponentDetails ,
}) => {
  const [smallModal, setSmallModal] = useState({
    hover1: false,
    hover2: false,
    show: false,
  });
  const [activeComponent, setActiveComponent] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [isLoading, setisLoading] = useState(true);
  const [crmDetails, setCrmDetails] = useState([]);
  const [applicantDetailsData, setApplications] = useState([]);
  const [fusionDetails, setFusionDetails] = useState([]);
  const [webhookDetails, setWebhookDetails] = useState([]);
  const [lmsDetails, setLmsDetails] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [request, setRequest] = useState({});
  const [response, setResponse] = useState(null);
  const [docDetails, setDocDetails] = useState([]);
  const [tpDetails, setTpDetails] = useState([]);
  const [filteredTpDetails, setFilteredTpDetails] = useState([]);
  const [tpArray, setTpArray] = useState([]);
  const [inputRequest, setInputRequest] = useState([]);
  const [notification, setNotification] = useState([]);
  const [utr, setUtr] = useState([]);
  const [systemDate, setSystemDate] = useState([]);
  const [updateFinance, setUpdateFinance] = useState([]);
  const [paymentProcess, setPaymentProcess] = useState([]);
  const [paymentReceipt, setPaymentReceipt] = useState([]);
  const [canPreviousPage, setcanPreviousPage] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  const [canNextPage, setcanNextPage] = useState(true);
  const [tpData, setTpData] = useState("");
  const [givenStart, setGivenStart] = useState(1);
  const [givenEnd, setGivenEnd] = useState(10);
  const [apiNameValue, setApiNameValue] = useState("");
  const [apiName, setApiName] = useState([
    { id: "bre_request", name: "bre_request" },
    { id: "create_customer", name: "create_customer" },
    { id: "create_mandate", name: "create_mandate" },
    { id: "create-lead-uat", name: "create-lead-uat" },
    { id: "create-lead", name: "create-lead" },
    { id: "create_finance", name: "create_finance" },
    { id: "get_status", name: "get_status" },
    { id: "register-lead", name: "register-lead" },
    { id: "s3_bucket", name: "s3_bucket" },
    { id: "update-lead", name: "update-lead" },
    { id: "upload_document_and_create", name: "upload_document_and_create" },
    { id: "upload_document_and_save", name: "upload_document_and_save" },
    { id: "webhook", name: "webhook" },
  ]);
  const [pageNos, setPageNo] = useState(1);
  const [perPageRecord, setPerPageRecord] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [getStatusRun, setGetStatusRun] = useState({});

  const [pagination, setpagination] = useState({
    pre_page_records: 10,
    total_rows: 10,
    current_page: 1,
  });
  useEffect(() => {
    (async () => {
      setisLoading(true);
      const id = match?.params?.id;
      // await viewApplicantDetails({ application_no: id });
      const data = {
        application_no: id
      }
      const res = await callWebService(
        callTypes.post,
        data,
        Config.applicationDetails,
    );
    setApplications(res?.data?.data ?? []);
      setisLoading(false);
    })();
  }, []);

  const componentDetailApi = async (data) => {
    let resData =  await callWebService(
      callTypes.post,
      data,
      Config.componentDetails,
    );
    return resData;
  }

  useEffect(() => {
    (async () => {
      const id = match?.params?.id;
      setGetStatusRun({});

      if (selectedTab === 1) {
        setisLoading(true);
        const data = {
            actionType: "crm",
            applicationNo: id,
          }
      const res = await componentDetailApi(data);
      setCrmDetails(res?.data?.data ?? []);
        setisLoading(false);
      }
      if (selectedTab === 2) {
        setisLoading(true);
        getTpRequsetData();
      }
      if (selectedTab === 3) {
        setisLoading(true);
        const data = {
            actionType: "fusion",
            applicationNo: id,
          }
        const res = await componentDetailApi(data);
          setFusionDetails(res?.data?.data ?? []);
          setisLoading(false);
      }
      if (selectedTab === 4) {
        setisLoading(true);
        const res = await componentDetailApi({
          actionType: "webhook",
          applicationNo: id,
        });
        setWebhookDetails(res?.data?.data ?? []);
        setisLoading(false);
      }
      if (selectedTab === 5) {
        setisLoading(true);
        const res = await componentDetailApi({
          actionType: "pennant",
          applicationNo: id,
        });
        setLmsDetails(res?.data?.data ?? []);
        const resSystemDate = await componentDetailApi({
          actionType: "systemdate",
          applicationNo: id,
        });
        setSystemDate(resSystemDate?.data?.data ?? []);
        const resUpdateFinance = await componentDetailApi({
          actionType: "updateFinance",
          applicationNo: id,
        });
        setUpdateFinance(resUpdateFinance?.data?.data ?? []);
        setisLoading(false);
      }
     
      if (selectedTab === 6) {
        setisLoading(true);
        const res = await componentDetailApi({
          actionType: "documents",
          applicationNo: id,
        });
        setDocDetails(res?.data?.data ?? []);
        setisLoading(false);
      }
      if (selectedTab === 7) {
        setisLoading(true);
        const res = await componentDetailApi({
          actionType: "inputrequest",
          applicationNo: id,
        });
        setInputRequest(res?.data?.data ?? []);
        setisLoading(false);
      }
      if (selectedTab === 8) {
        setisLoading(true);
        const res = await componentDetailApi({
          actionType: "utr",
          applicationNo: id,
        });
        setUtr(res?.data?.data ?? []);
        setisLoading(false);
      }
      if (selectedTab === 9) {
        setisLoading(true);
        const res = await componentDetailApi({
          actionType: "notification",
          applicationNo: id,
        });
        setNotification(res?.data?.data ?? []);
        setisLoading(false);
      }
      if (selectedTab === 10) {
        setisLoading(true);
        const res = await componentDetailApi({
          actionType: "paymentProcess",
          applicationNo: id,
        });
        setPaymentProcess(res?.data?.data ?? []);
        setisLoading(false);
      }
      if (selectedTab === 11) {
        setisLoading(true);
        const res = await componentDetailApi({
          actionType: "paymentReceipt",
          applicationNo: id,
        });
        setPaymentReceipt(res?.data?.data ?? []);
        setisLoading(false);
      }
    })();
  }, [selectedTab]);

  const getResponse = (response) => {
    if (response?.length > 10) {
      return response.substring(0, 10);
    }
    return response;
  };
  const handleTabSelection = (e) => {
    const value = e.target.innerText.split("\n")[0];
    if (activeTab == value) {
      setActiveTab(0);
    } else {
      setActiveTab(value);
    }
  };

  const getTpRequsetData = async (page, refreshData) => {
    setPageNo(page ? page : 1);
    const applicationId = match?.params?.id;

    const res = await componentDetailApi({
      actionType: "thirdparty",
      applicationNo: applicationId,
      pageNo: page ? page : 1,
      pageSize: perPageRecord ? perPageRecord : 10,
      searchName: refreshData ? "" : tpData,
      apiName: refreshData ? "" : apiNameValue,
    });
    setTpDetails(res?.data?.data?.tp_request_list ?? []);
    setPerPageRecord(res?.data?.data?.pagination?.pre_page_records);
    setTotalRecord(res?.data?.data?.pagination?.total_rows);
    setFilteredTpDetails(res?.data?.data?.tp_request_list ?? []);
    setTpArray(res?.data?.data?.tp_request_list ?? []);
    setisLoading(false);
  };
  const getMessage = (message) => {
    const messageData = message && JSON.parse(message);
    if (messageData?.message) {
      if (messageData?.message?.errors?.message) {
        return messageData?.message?.errors?.message[0];
      }
      return messageData?.message;
    }

    return "NA";
  };

  const getSystemDateMsg = (data) => {
    if (data?.returnStatus) {
      return data?.returnStatus?.returnText;
    } else {
      return "na";
    }
  };

  const getDocumentMsg = (msg) => {
    if (msg?.statusText) {
      return msg?.statusText.toLowerCase() == "ok" ? "Success" : "";
    } else if (msg?.message) {
      return JSON.stringify(msg?.message);
    } else {
      return JSON.stringify(msg);
    }
  };

  const getFusionMessage = (message, data) => {
    const messageData =
      typeof message === "object" ? message : JSON.parse(message);
    let fusionData = messageData;
    if (fusionData?.message && data == "fusion") {
      if (fusionData?.message?.errors?.message) {
        return fusionData?.message?.errors?.message[0];
      }
      return Object.keys(fusionData?.message).length === 0
        ? JSON.stringify(fusionData?.message)
        : fusionData?.message;
    }
    return "NA";
  };

  const filterThirdPartyData = (tqValue, apiName) => {
    let filtData = [];
    if (tqValue == "" && apiName == "") {
      return;
    }
    if (tqValue !== "" && apiName != "") {
      filtData = tpDetails.filter(
        (data) =>
          (data.http_status_code.toString().includes(tqValue) ||
            data.application_no.toLowerCase().includes(tqValue)) &&
          data.api_name == apiName
      );
    } else if (tqValue !== "" && apiName == "") {
      filtData = tpDetails.filter(
        (data) =>
          data.http_status_code.toString().includes(tqValue) ||
          data.application_no.toLowerCase().includes(tqValue)
      );
    } else if (tqValue == "" && apiName !== "") {
      filtData = tpDetails.filter((data) => data.api_name == apiName);
    }
    setFilteredTpDetails(filtData);
  };

  const getPennantMsg = (msg) => {
    if (msg === "") {
      return "";
    }
    const data = JSON.parse(msg);
    if (data?.statusText !== "") {
      return data?.statusText ? data?.statusText : "Response not found";
    } else if (data?.data?.returnStatus) {
      return data?.data?.returnStatus?.returnText;
    }
  };

  const getPennantMsg2 = (msg) => {
    if (msg === "") {
      return "";
    }
    const data = JSON.parse(msg);
    if (data?.data?.returnText !== "") {
      return data?.data?.returnText ? data?.data?.returnText : "Response not found";
    }
  };

  const getUpdateFinanceMsg = (msg) => {
    if (msg === "") {
      return "";
    }
    const data = JSON.parse(msg);
    if (data?.returnStatus) {
      return data?.returnStatus
        ? data?.returnStatus?.returnText
        : "Response not found";
    }
  };

  const utrMsg = (data) => {
    if (data?.data?.returnStatus) {
      return data?.data?.returnStatus?.returnText;
    } else {
      return null;
    }
  };

  const getWebhookMsg = (msg) => {
    if (msg?.data) {
      return msg?.data?.status;
    } else {
      return "NA";
    }
  };

  const onChangeFilter = async (e) => {
    const tqValue = e.target.value;
    setTpData(tqValue);
  };

  const filterData = () => {
    if (tpData == "" && apiNameValue == "") {
      return;
    }
    getTpRequsetData();
  };

  const reFreshData = async () => {
    setTpData("");
    setApiNameValue("");
    getTpRequsetData(pageNos, 'refreshData');

    setPageNo(1);
    const applicationId = match?.params?.id;

    // const res = await viewComponentDetails({
    //   actionType: "thirdparty",
    //   applicationNo: applicationId,
    //   pageNo: 1,
    //   pageSize: 10,
    //   searchName: "",
    //   apiName: "",
    // });
    // setTpDetails(res?.payload?.tp_request_list ?? []);
    // setPerPageRecord(res?.payload?.pagination?.pre_page_records);
    // setTotalRecord(res?.payload?.pagination?.total_rows);
    // setFilteredTpDetails(res?.payload?.tp_request_list ?? []);
    // setTpArray(res?.payload?.tp_request_list ?? []);
    // setisLoading(false);
  };

  const nextEndPage = (page) => {
    getTpRequsetData(page, "next");
  };

  const previousStartPage = (page) => {
    getTpRequsetData(page, "previous");
  };

  const handleKycInputChange = (e) => {
    const valueData = e.target.value;
    setApiNameValue(valueData);
  };
  const testJSON = (text) => {
    if (typeof text !== "string") {
      return false;
    }
    try {
      var json = JSON.parse(text);
      return json;
    } catch (error) {
      return false;
    }
  };

  const inputSearch = () => {
    return (
      <>
        <div style={{ display: "inline-block" }}>
          <input
            type="text"
            className="search-button"
            name="search"
            value={tpData}
            placeholder="Status Code"
            onChange={(e) => onChangeFilter(e)}
          />
          &nbsp;
          <div className="dropdown1" style={{ float: "none" }}>
            <DropDownFilter
              value={apiNameValue}
              name="apiName"
              optionList={apiName}
              optIdKey="id"
              optValueKey="name"
              //id="apiName"
              placeholder={localization.placeholders.apiName}
              onChange={(e) => handleKycInputChange(e)}
            />
          </div>
          &nbsp;
          <button className="btn btn-primary" onClick={() => filterData()}>
            Search
          </button>
          &nbsp;
          <button
            className="btn btn-warning resetBtn"
            onClick={() => reFreshData()}
          >
            Reset
          </button>
        </div>
        <div style={{ float: "right", position: "relative" }}>
          {tpDetails && tpDetails.length > 0 ? (
            <b
              className="pagination-value"
              data-hovered={smallModal.hover1}
              style={{ cursor: "pointer" }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover1: false, hover2: false });
              }}
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover1: true, show: true });
              }}
            >
              {pageNos == 1 ? pageNos : (pageNos - 1) * perPageRecord + 1}-
              {pageNos * perPageRecord > totalRecord
                ? totalRecord
                : pageNos * perPageRecord}{" "}
              of {totalRecord}
            </b>
          ) : (
            <span className="pagination-value">0 - 0 of 0</span>
          )}
          &nbsp;
          {smallModal.hover1 && (
            <div
              className="small-modal"
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover2: true });
              }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover2: false, hover1: false });
              }}
            >
              <span
                className="small-modal-option"
                data-disabled={pageNos === 1 && true}
                onClick={() => previousStartPage(1)}
              >
                Newest
              </span>
              <span
                className="small-modal-option"
                data-disabled={totalRecord <= pageNos * perPageRecord && true}
                onClick={() =>
                  previousStartPage(Math.ceil(totalRecord / perPageRecord))
                }
              >
                Oldest
              </span>
            </div>
          )}
          <button
            className="pagination-button"
            onClick={() => previousStartPage(pageNos - 1)}
            title="Newer"
            data-disabled={pageNos <= 1 && true}
            disabled={pageNos <= 1}
          >
            {"<"}
          </button>
          &nbsp;
          <button
            className="pagination-button"
            onClick={() => nextEndPage(pageNos + 1)}
            title="Older"
            data-disabled={
              totalRecord <= pageNos * perPageRecord || tpDetails.length === 0
            }
            disabled={
              totalRecord <= pageNos * perPageRecord || tpDetails.length === 0
            }
          >
            {">"}
          </button>
        </div>
      </>
    );
  };

  const nextPage = () => {
    setcanPreviousPage(true);

    const check = {
      kycType: "",
      pageNo: pageNos + 1,
      pageSize: 10,
      searchAppNo: "",
      searchName: "",
    };
    //setPageNo(pageNo + 1);
    //handleFilterSearch(check);
  };
  const previousPage = () => {
    if (pageNos >= 1) {
      const check = {
        kycType: "",
        pageNo: pageNos - 1,
        pageSize: 10,
        searchAppNo: "",
        searchName: "",
      };
      //setPageNo(pageNo - 1);
      //handleFilterSearch(check);
    }
  };
  const gotoPage = (param) => {
    const check = {
      kycType: "",
      pageNo: param,
      pageSize: 10,
      searchAppNo: "",
      searchName: "",
    };
    setPageNo(param);
  };
  const renderHeader = () => {
    let headerElement = [
      "S. No.",
      "API Name",
      "Request / Response",
      "Message",
      "HTTP Status Code",
      "Created At",
      "Updated At",
    ];

    return headerElement.map((key, index) => {
      return <th key={index}>{key}</th>;
    });
  };

  const recordsPerPage = [
    { records_id: 10, records_value: 10 },
    { records_id: 20, records_value: 20 },
    { records_id: 30, records_value: 30 },
    { records_id: 50, records_value: 50 },
  ];

  const handleRecordsPerPage = async (recordSize) => {
    setPageNo(1);

    const applicationId = match?.params?.id;
    const res = await componentDetailApi({
      actionType: "thirdparty",
      applicationNo: applicationId,
      pageNo: 1,
      pageSize: recordSize ? recordSize : perPageRecord,
      searchName: tpData,
      apiName: apiNameValue,
    });
    setTpDetails(res?.data?.data?.tp_request_list ?? []);
    setPerPageRecord(res?.data?.data?.pagination?.pre_page_records);
    setTotalRecord(res?.data?.data?.pagination?.total_rows);
    setFilteredTpDetails(res?.data?.data?.tp_request_list ?? []);
    setTpArray(res?.data?.data?.tp_request_list ?? []);
    setisLoading(false);
  };

  const handleAscendingOrder = () => {};
  const handleDescendingOrder = () => {};

  const changeStatusText = (data, tryCount) => {
    let statusName;
    if (data == 0 && tryCount < 3) {
      statusName = "In Progress";
    } else if (data == 1 && tryCount <= 3) {
      statusName = "Complete";
    } else if (data == 0 && tryCount >= 3) {
      statusName = "Failed";
    }
    return statusName;
  };

  const changeManualText = (data) => {
    let statusName;
    if (data == 0) {
      statusName = "";
    } else if (data == 1) {
      statusName = "Manual";
    }
    return statusName;
  };

  const changeFusionText = (data) => {
    let statusName;
    if (data == 0) {
      statusName = "In Progress";
    } else if (data == 1) {
      statusName = "Complete";
    } else if (data == 2) {
      statusName = "Reject";
    } else if (data == 3) {
      statusName = "On Hold";
    }
    return statusName;
  };

  const showStatusText = (data) => {
    let statusName;
    if (data == 0) {
      statusName = "In Progress";
    } else if (data == 1) {
      statusName = "Complete";
    } else if (data == 2) {
      statusName = "Failed";
    } else if (data == 3) {
      return (statusName = "On Hold");
    }
    return statusName;
  };

  const changePenantStatusText = (pennantStatus, fusionApprovalStatus) => {
    let statusName;
    if (fusionApprovalStatus == 2) {
      return (statusName = "NA");
    }
    if (pennantStatus == 0) {
      statusName = "In Progress";
    } else if (pennantStatus == 1) {
      statusName = "Complete";
    } else if (pennantStatus == 2) {
      statusName = "Failed";
    } else if (pennantStatus === 3) {
      statusName = "Rejected";
    }
    return statusName;
  };

  const statusText = (status) => {
    let statusName;
    if (["", "0"].includes(status)) {
      statusName = "In Progress";
    } else if (status == "1") {
      statusName = "Complete";
    } else if (status == "2") {
      statusName = "Failed";
    } else if (status == "3") {
      statusName = "Rejected";
    }
    return statusName;
  };

  const runCallApi = async (crmId) => {
    const applicationNo = match?.params?.id;
    const data = {
      applicationNo: applicationNo,
      crm_id: crmId,
    };
    const res = await callWebService(
      callTypes.post,
      data,
      Config.queueProductVerification
    );
    setGetStatusRun(res.data.data);
  };
 const handleRetryCount=async(appNo)=>{
  const id = match?.params?.id;
  let payload={
    applicationNo:appNo,
  };
  const res = await callWebService(
    callTypes.post,
    payload,
    Config.retriggerKfs
  );
  if(res?.data?.code==200){
    setisLoading(true);
    const res = await componentDetailApi({
      actionType: "pennant",
      applicationNo: id,
    });
    setLmsDetails(res?.data?.data ?? []);
    const resSystemDate = await componentDetailApi({
      actionType: "systemdate",
      applicationNo: id,
    });
    setSystemDate(resSystemDate?.data?.data ?? []);
    const resUpdateFinance = await componentDetailApi({
      actionType: "updateFinance",
      applicationNo: id,
    });
    setUpdateFinance(resUpdateFinance?.data?.data ?? []);
    setisLoading(false);
  }

 }
  const resendCallApi = async (applicationId, id , kfs_api_name) => {
    const data = {
      application_no: applicationId,
      id: id,
      kfs_api_name: kfs_api_name
    };
    const res = await callWebService(
      callTypes.post,
      data,
      Config.resetNotificaiton
    );
    
    if (res.data.code === 200) {

      const res = await componentDetailApi({
        actionType: "notification",
        applicationNo: applicationId,
      });
      setNotification(res?.data?.data ?? []);

    }
  }

  const encodeReqRes = (data) => {
    setModalShow(true);
    if (data?.encode_request) {
      const req = trim(
        typeof data?.encode_request === "object"
          ? JSON.stringify(data?.encode_request)
          : data?.encode_request
      );
      setRequest(req);
    }
    if (data?.encode_response) {
      const res = trim(
        typeof data?.encode_response === "object"
          ? JSON.stringify(data?.encode_response)
          : data?.encode_response
      );
      setResponse(res);
    }
  };

  const decodeReqRes = (data) => {
    setModalShow(true);
    if (data?.decode_request) {
      const req = trim(
        typeof data?.decode_request === "object"
          ? JSON.stringify(data?.decode_request)
          : data?.decode_request
      );
      setRequest(req);
    }
    if (data?.decode_response) {
      const res = trim(
        typeof data?.decode_response === "object"
          ? JSON.stringify(data?.decode_response)
          : data?.decode_response
      );
      setResponse(res);
    }
  };

  const showText = (data) => {
    let text;
    if (data === 1) {
      text = "Complete";
    } else {
      text = "Failed";
    }
    return text;
  };

  const changeConditionText = (crmStatus, fusionStatus, pennantStatus) => {
    let statusName;
    if (pennantStatus == 2 || fusionStatus == 2 || crmStatus == 2) {
      statusName = "Failed";
    } else if (crmStatus == 1 && fusionStatus == 1 && pennantStatus == 1) {
      statusName = "Complete";
    } else if (pennantStatus == 0 || fusionStatus == 0 || crmStatus == 0) {
      statusName = "In Progress";
    }

    return statusName;
  };
  const jsonStyle = {
    propertyStyle: { color: "red" },
    stringStyle: { color: "green" },
    numberStyle: { color: "darkorange" },
  };
  const renderAllFields = (type) => {
    const createLeadData =
      crmDetails &&
      crmDetails?.filter((item) => trim(item.api_name) == "create-lead");
    const updateLeadData =
      crmDetails &&
      crmDetails?.filter((item) => trim(item.api_name) == "update_lead");
    const reinitiateLeadData =
      crmDetails &&
      crmDetails?.filter((item) => trim(item.api_name) == "reinitiate_lead");
    const getStatusData =
      Object.keys(getStatusRun).length > 0
        ? getStatusRun
        : crmDetails &&
          crmDetails?.filter((item) => trim(item.api_name) == "get_status");
    const fusionData = fusionDetails && fusionDetails[0];
    const webHookData = webhookDetails && webhookDetails;
    const createFinance =
      lmsDetails &&
      lmsDetails?.filter((item) => trim(item.api_name) == "create_finance")[0];
    const disbursementData =
      lmsDetails &&
      lmsDetails?.filter((item) => trim(item.api_name) == "disbursement")[0];
    const addVasData =
      lmsDetails &&
      lmsDetails?.filter((item) => trim(item.api_name) == "add_vas")[0];

      const approveLoanData =
      lmsDetails &&
      lmsDetails?.filter((item) => ((trim(item.api_name) == "approve_loan") || (trim(item.api_name) =="push_forward")))[0];
      const webhookDataVal = crmDetails && crmDetails.filter(item => item.webhook)[0];
      const webhookDataValArray=webhookDataVal && webhookDataVal.webhook;
    //const createCustomer=lmsDetails && lmsDetails?.filter((item)=>trim(item.api_name)=="create_customer")[0];
    const createCustomer =
      lmsDetails &&
      lmsDetails?.filter(
        (item) =>
          trim(item.applicant_type).toLowerCase() == "primary" &&
          trim(item.api_name) == "create_customer"
      );
    const createCoApplicantCustomer =
      lmsDetails &&
      lmsDetails?.filter(
        (item) => trim(item.applicant_type).toLowerCase() !== "primary"
      );
    const createMandate =
      lmsDetails &&
      lmsDetails?.filter((item) => trim(item.api_name) == "create_mandate")[0];
    //const updateMandate = lmsDetails && lmsDetails?.filter((item)=>trim(item.api_name)=="update_mandate");
    const createKfsDoc = lmsDetails && lmsDetails?.filter((item)=>trim(item.api_name)=="create_kfs_doc");
    const approveMandate =
      lmsDetails &&
      lmsDetails?.filter((item) => trim(item.api_name) == "approve_mandate");
    const utrData = utr && utr[0];
    const notificationData = notification;

    if (type === "applicant") {
      return (
        <>
          <FormAccordion
            key={7}
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            collapse={false}
            title={localization.applicationDetail}
          >
            <div className="panel-card-table">
              <div className="main-container">
                {applicantDetailsData && (
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Partner Number </th>
                        <th>DA number</th>
                        <th>CRM</th>
                        <th>Fusion</th>
                        <th>CIF</th>
                        <th>LAN</th>
                        <th>Mandate Ref. Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{applicantDetailsData[0]?.partner_name}</td>
                        <td>{applicantDetailsData[0]?.application_no}</td>
                        <td>{applicantDetailsData[0]?.crm_id}</td>
                        <td>{applicantDetailsData[0]?.digital_alliance_id}</td>
                        <td>{applicantDetailsData[0]?.primary_cif}</td>
                        <td>{applicantDetailsData[0]?.lan_number}</td>
                        <td>{applicantDetailsData[0]?.mandate_reference_no}</td>
                      </tr>
                    </tbody>
                  </Table>
                )}
              </div>
            </div>
          </FormAccordion>

          <FormAccordion
            key={8}
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            collapse={true}
            title={localization.partnerDetails}
          >
            <div className="panel-card-table">
              <div className="main-container">
                {applicantDetailsData && (
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>{localization.partnerName}</th>
                        <th>{localization.partnerCode}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{applicantDetailsData[0]?.partner_name}</td>
                        <td>{applicantDetailsData[0]?.partner_code}</td>
                      </tr>
                    </tbody>
                  </Table>
                )}
              </div>
            </div>
          </FormAccordion>

          <FormAccordion
            key={9}
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            collapse={true}
            title={localization.statusDetails}
          >
            <div className="panel-card-table">
              <div className="main-container">
                {applicantDetailsData && (
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>BRE Process Status</th>
                        <th>CRM Process Status</th>
                        <th>Fusion Process Status</th>
                        <th>Pennant Process Status</th>
                        <th>{localization.applicationStatus}</th>
                        <th>Remark</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Complete</td>
                        <td>
                          {showStatusText(applicantDetailsData[0]?.crm_status)}
                        </td>
                        <td>
                          {showStatusText(
                            applicantDetailsData[0]?.fusion_approval_status
                          )}
                        </td>
                        <td>
                          {changePenantStatusText(
                            applicantDetailsData[0]?.pennant_status,
                            applicantDetailsData[0]?.fusion_approval_status
                          )}
                        </td>
                        <td>{statusText(applicantDetailsData[0]?.status)}</td>
                        <td>{applicantDetailsData[0]?.application_remark}</td>
                      </tr>
                    </tbody>
                  </Table>
                )}
              </div>
            </div>
          </FormAccordion>

          <FormAccordion
            key={10}
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            collapse={true}
            title="BRE Details"
          >
            <div className="panel-card-table">
              <div className="main-container">
                {applicantDetailsData && (
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Api name</th>
                        <th>Request/Response</th>
                        {/* <th>Message</th> */}
                        {/* <th>Bre Status</th> */}
                        <th>HTTP Status Code</th>
                        <th>Create At</th>
                        <th>Update At</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{applicantDetailsData[0]?.bre_api_name}</td>
                        <td>
                          <span
                            style={{ cursor: "pointer" }}
                            className="anchorNew"
                            onClick={() =>
                              handleWebhookResponse(
                                applicantDetailsData[0],
                                true
                              )
                            }
                          >
                            <u>Request / Response</u>
                          </span>
                        </td>
                        {/* <td>-</td> */}
                        {/* <td>{showStatusText(applicantDetailsData[0]?.bre_status)}</td> */}
                        <td>{applicantDetailsData[0]?.brestatus}</td>
                        <td>
                          {applicantDetailsData[0]?.bre_created_at
                            ? dateParser(
                                applicantDetailsData[0].bre_created_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {applicantDetailsData[0]?.bre_created_at
                            ? dateParser(
                                applicantDetailsData[0]?.bre_created_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>

                        <td>
                          {applicantDetailsData[0]?.bre_updated_at
                            ? dateParser(
                                applicantDetailsData[0].bre_updated_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {applicantDetailsData[0]?.bre_updated_at
                            ? dateParser(
                                applicantDetailsData[0]?.bre_updated_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                )}
              </div>
            </div>
          </FormAccordion>
        </>
      );
    }
    if (type === "crm") {
      return (
        <>
          <FormAccordion
            activeTab={activeTab}
            collapse={false}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Create Lead"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Request / Response</th>
                      <th>CRM ID</th>
                      <th>Message</th>
                      <th>API Count</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed TIme</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {createLeadData && (
                    <tbody>
                      {createLeadData?.map((createLead) => (
                        <tr key={createLead.crm_id}>
                        <td>
                          <span
                            style={{ cursor: "pointer" }}
                            className="anchorNew"
                            onClick={() => handleResponse(createLead)}
                          >
                            <u>Request / Response</u>
                          </span>
                        </td>
                        <td>{createLead.crm_id}</td>
                        <td>{getMessage(createLead?.response)}</td>
                        <td>{createLead.try_count}</td>
                        <td>{createLead.http_status_code}</td>
                        <td>
                          {changeStatusText(
                            createLead.status,
                            createLead.try_count
                          )}
                        </td>
                        <td>{createLead.message_id}</td>
                        <td>
                          {createLead.pushed_to_queue_time
                            ? dateParser(
                                createLead.pushed_to_queue_time,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {createLead.pushed_to_queue_time
                            ? dateParser(
                                createLead.pushed_to_queue_time,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {createLead.created_at
                            ? dateParser(
                                createLead.created_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {createLead.created_at
                            ? dateParser(
                                createLead.created_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {createLead.updated_at
                            ? dateParser(
                                createLead.updated_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {createLead.updated_at
                            ? dateParser(
                                createLead.updated_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                      </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Update Lead"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CRM ID</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>API Count</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {updateLeadData && (
                    <tbody>
                      {updateLeadData?.map((updateLead) => (
                        <tr key={updateLead.crm_id}>
                          <td>{updateLead.crm_id}</td>
                          <td>
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => handleResponse(updateLead)}
                            >
                              <u>Request / Response</u>
                            </a>
                          </td>
                          <td>{getMessage(updateLead?.response)}</td>
                          <td>{updateLead.try_count}</td>
                          <td>{updateLead.http_status_code}</td>
                          <td>
                            {" "}
                            {changeStatusText(
                              updateLead.status,
                              updateLead.try_count
                            )}
                          </td>
                          <td>{updateLead.message_id}</td>
                          <td>
                            {updateLead.pushed_to_queue_time
                              ? dateParser(
                                  updateLead.pushed_to_queue_time,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {updateLead.pushed_to_queue_time
                              ? dateParser(
                                  updateLead.pushed_to_queue_time,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {updateLead.created_at
                              ? dateParser(
                                  updateLead.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {updateLead.created_at
                              ? dateParser(
                                  updateLead.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {updateLead.updated_at
                              ? dateParser(
                                  updateLead.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {updateLead.updated_at
                              ? dateParser(
                                  updateLead.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Reinitiate Lead"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CRM ID</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>API Count</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {reinitiateLeadData && (
                    <tbody>
                      {reinitiateLeadData?.map((reinitiateLead) => (
                        <tr key={reinitiateLead.crm_id}>
                          <td>{reinitiateLead.crm_id}</td>
                          <td>
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => handleResponse(reinitiateLead)}
                            >
                              <u>Request / Response</u>
                            </a>
                          </td>
                          <td>{getMessage(reinitiateLead?.response)}</td>
                          <td>{reinitiateLead.try_count}</td>
                          <td>{reinitiateLead.http_status_code}</td>
                          <td>
                            {" "}
                            {changeStatusText(
                              reinitiateLead.status,
                              reinitiateLead.try_count
                            )}
                          </td>
                          <td>{reinitiateLead.message_id}</td>
                          <td>
                            {reinitiateLead.pushed_to_queue_time
                              ? dateParser(
                                  reinitiateLead.pushed_to_queue_time,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {reinitiateLead.pushed_to_queue_time
                              ? dateParser(
                                  reinitiateLead.pushed_to_queue_time,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {reinitiateLead.created_at
                              ? dateParser(
                                  reinitiateLead.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {reinitiateLead.created_at
                              ? dateParser(
                                  reinitiateLead.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {reinitiateLead.updated_at
                              ? dateParser(
                                  reinitiateLead.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {reinitiateLead.updated_at
                              ? dateParser(
                                  reinitiateLead.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
          {/* <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Get Status"}
            historybtn={false}
            rerunBtn={true}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CRM ID</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>API Count</th>
                      <th>HTTP Status Code</th>
                      <th>Approve by status</th>
                      <th>Status</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  { getStatusData && (
                    <tbody>
                      {getStatusData?.map((getStatus) => (
                        <tr key={getStatus.crm_id}>
                          <td>{getStatus.crm_id}</td>
                          <td>
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => handleResponse(getStatus)}
                            >
                              <u>Request / Response</u>
                            </a>
                          </td>
                          <td>{getMessage(getStatus.response)}</td>
                          <td>{getStatus.try_count}</td>
                          <td>{getStatus.http_status_code}</td>
                          <td>{changeManualText(getStatus.is_manual)}</td>
                          <td>
                            {changeStatusText(
                              getStatus.status,
                              getStatus.try_count
                            )}
                          </td>
                          <td>{getStatus.message_id}</td>
                          <td>
                            {getStatus.pushed_to_queue_time
                              ? dateParser(
                                  getStatus.pushed_to_queue_time,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {getStatus.pushed_to_queue_time
                              ? dateParser(
                                  getStatus.pushed_to_queue_time,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {getStatus.created_at
                              ? dateParser(
                                  getStatus.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {getStatus.created_at
                              ? dateParser(
                                  getStatus.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {getStatus.updated_at
                              ? dateParser(
                                  getStatus.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {getStatus.updated_at
                              ? dateParser(
                                  getStatus.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            <button
                              className="btn btn-primary"
                              onClick={() => runCallApi(getStatus?.crm_id)}
                            >
                              Run
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion> */}
          {/* <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Get Status Webhook"}
            historybtn={false}
            rerunBtn={true}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CRM ID</th>
                      <th>Api Name</th>
                      <th>Request/Response</th>
                      <th>Status</th>
                      <th>HTTP Status Code</th>
                      <th>Product Status</th>
                      <th>Product Status Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    {webhookDataValArray?.map((val) => {
                      return (
                        <tr key={val?.id}>
                          <td>{val?.crm_id}</td>
                          <td>{val?.api_name}</td>
                          <td>
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() =>
                                handleResponse({
                                  request: val?.request,
                                  response: val?.response,
                                })
                              }
                            >
                              <u>Request / Response</u>
                            </a>
                          </td>
                          <td>
                            {val?.status === 1
                              ? "Complete"
                              : val?.status === 2
                              ? "Failed"
                              : null}
                          </td>
                          <td>{val?.http_status_code}</td>
                          <td>{val?.product_status}</td>
                          <td>{val?.product_status_remark}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </FormAccordion> */}
        </>
      );
    } else if (type === "fusion") {
      return (
        <>
          <FormAccordion
            activeTab={activeTab}
            collapse={false}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Create Lead"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Fusion ID</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>API Count</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {fusionData && (
                    <tbody>
                      <tr>
                        <td>{fusionData.digital_alliance_id}</td>
                        <td>
                          <a
                            style={{ cursor: "pointer" }}
                            className="anchorNew"
                            onClick={() => handleResponse(fusionData)}
                          >
                            <u>Request / Response</u>
                          </a>
                        </td>
                        <td>
                          {getFusionMessage(fusionData?.response, "fusion")}
                        </td>
                        <td>{fusionData.try_count}</td>
                        <td>{fusionData.http_status_code}</td>
                        <td>
                          {changeStatusText(
                            fusionData.status,
                            fusionData.try_count
                          )}
                        </td>
                        <td>{fusionData.message_id}</td>
                        <td>
                          {fusionData.pushed_to_queue_time
                            ? dateParser(
                                fusionData.pushed_to_queue_time,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {fusionData.pushed_to_queue_time
                            ? dateParser(
                                fusionData.pushed_to_queue_time,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {fusionData.created_at
                            ? dateParser(
                                fusionData.created_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {fusionData.created_at
                            ? dateParser(
                                fusionData.created_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {fusionData.updated_at
                            ? dateParser(
                                fusionData.updated_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {fusionData.updated_at
                            ? dateParser(
                                fusionData.updated_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>

          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Get Status"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Remark</th>
                      <th>Created At</th>
                    </tr>
                  </thead>
                  {fusionData && (
                    <tbody>
                      <tr>
                        <td>
                          {changeFusionText(fusionData?.fusion_approval_status)}
                        </td>
                        <td>{fusionData?.fusion_approval_status_comments}</td>
                        <td>
                          {fusionData?.fusion_approval_status_update_time
                            ? dateParser(
                                fusionData.fusion_approval_status_update_time,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {fusionData.fusion_approval_status_update_time
                            ? dateParser(
                                fusionData.fusion_approval_status_update_time,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
        </>
      );
    } else if (type === "pennant") {
      return (
        <>
          <FormAccordion
            activeTab={activeTab}
            collapse={false}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Create Customer"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CIF</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>HTTP Status Code</th>
                      <th>API Count</th>
                      <th>Applicant type</th>
                      <th>Status</th>
                      <th>Pennant Message ID</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {createCustomer && (
                    <tbody>
                      {createCustomer.map((data, idx) => (
                        <tr key={idx}>
                          <td>{data.cif}</td>
                          <td>
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => handleResponse(data)}
                            >
                              <u>Request / Response</u>
                            </a>
                          </td>
                          <td>{getPennantMsg(data?.response)}</td>
                          <td>{data.http_status_code}</td>
                          <td>{data.try_count}</td>
                          <td>{data.applicant_type}</td>
                          <td>
                            {changeStatusText(data.status, data.try_count)}
                          </td>
                          <td>{data.process_message_id}</td>
                          <td>{data.message_id}</td>
                          <td>
                            {data.pushed_to_queue_time
                              ? dateParser(
                                  data.pushed_to_queue_time,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.pushed_to_queue_time
                              ? dateParser(
                                  data.pushed_to_queue_time,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {data.created_at
                              ? dateParser(
                                  data.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.created_at
                              ? dateParser(
                                  data.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {data.updated_at
                              ? dateParser(
                                  data.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.updated_at
                              ? dateParser(
                                  data.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>

          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Co Applicant"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CIF</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>API Count</th>
                      <th>HTTP Status Code</th>
                      <th>Applicant type</th>
                      <th>Status</th>
                      <th>Message Id</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {createCoApplicantCustomer && (
                    <tbody>
                      {createCoApplicantCustomer.map((data, idx) => (
                        <tr>
                          <td>{data.cif}</td>
                          <td>
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => handleResponse(data)}
                            >
                              <u>Request / Response</u>
                            </a>
                          </td>
                          <td>{getPennantMsg(data?.response)}</td>
                          <td>{data.try_count}</td>
                          <td>{data.http_status_code}</td>
                          <td>{data.applicant_type}</td>
                          <td>
                            {changeStatusText(data.status, data.try_count)}
                          </td>
                          <td>{data.process_message_id}</td>
                          <td>{data.message_id}</td>
                          <td>
                            {data.pushed_to_queue_time
                              ? dateParser(
                                  data.pushed_to_queue_time,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.pushed_to_queue_time
                              ? dateParser(
                                  data.pushed_to_queue_time,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {data.created_at
                              ? dateParser(
                                  data.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.created_at
                              ? dateParser(
                                  data.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {data.updated_at
                              ? dateParser(
                                  data.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.updated_at
                              ? dateParser(
                                  data.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>

          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={localization.systemDate}
            collapse={true}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Pennant Message ID</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {systemDate && (
                    <tbody>
                      {systemDate.map((data, idx) => (
                        <tr key={idx}>
                          <td>
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => systemDateReqRes(data)}
                            >
                              <u>Request / Response</u>
                            </a>
                          </td>
                          <td>{getSystemDateMsg(data?.response)}</td>
                          <td>{data.http_status_code}</td>
                          <td>{changeFusionText(data.status)}</td>
                          <td>{data.process_message_id}</td>
                          <td>
                            {data.created_at
                              ? dateParser(
                                  data.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.created_at
                              ? dateParser(
                                  data.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {data.updated_at
                              ? dateParser(
                                  data.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.updated_at
                              ? dateParser(
                                  data.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>

          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Create Finance"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CIF</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>API Count</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Pennant Message ID</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {createFinance && (
                    <tbody>
                      <tr>
                        <td>{createFinance.cif}</td>
                        <td>
                          <a
                            style={{ cursor: "pointer" }}
                            className="anchorNew"
                            onClick={() => handleResponse(createFinance)}
                          >
                            <u>Request / Response</u>
                          </a>
                        </td>
                        <td>{getPennantMsg(createFinance?.response)}</td>
                        <td>{createFinance.try_count}</td>
                        <td>{createFinance.http_status_code}</td>
                        <td>
                          {changeStatusText(
                            createFinance.status,
                            createFinance.try_count
                          )}
                        </td>
                        <td>{createFinance.process_message_id}</td>
                        <td>{createFinance.message_id}</td>
                        <td>
                          {createFinance.pushed_to_queue_time
                            ? dateParser(
                                createFinance.pushed_to_queue_time,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {createFinance.pushed_to_queue_time
                            ? dateParser(
                                createFinance.pushed_to_queue_time,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {createFinance.created_at
                            ? dateParser(
                                createFinance.created_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {createFinance.created_at
                            ? dateParser(
                                createFinance.created_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {createFinance.updated_at
                            ? dateParser(
                                createFinance.updated_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {createFinance.updated_at
                            ? dateParser(
                                createFinance.updated_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Create KFS Doc"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CIF</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>API Count</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Pennant Message ID</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {createKfsDoc && createKfsDoc.map((createKfsDocVal,index) =>  (
                        <tr>
                          <td>{createKfsDocVal.cif}</td>
                          <td>
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => handleResponse(createKfsDocVal)}
                            >
                              <u>Request / Response</u>
                            </a>
                          </td>
                          <td>{getPennantMsg(createKfsDocVal?.response)}</td>
                          <td>{createKfsDocVal.try_count}</td>
                          <td>{createKfsDocVal.http_status_code}</td>
                          <td>
                            {changeStatusText(
                              createKfsDocVal.status,
                              createKfsDocVal.try_count
                            )}
                          </td>
                          <td>{createKfsDocVal.process_message_id}</td>
                          <td>{createKfsDocVal.message_id}</td>
                          <td>
                            {createKfsDocVal.pushed_to_queue_time
                              ? dateParser(
                                  createKfsDocVal.pushed_to_queue_time,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {createKfsDocVal.pushed_to_queue_time
                              ? dateParser(
                                  createKfsDocVal.pushed_to_queue_time,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {createKfsDocVal.created_at
                              ? dateParser(
                                  createKfsDocVal.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {createKfsDocVal.created_at
                              ? dateParser(
                                  createKfsDocVal.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {createKfsDocVal.updated_at
                              ? dateParser(
                                  createKfsDocVal.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {createKfsDocVal.updated_at
                              ? dateParser(
                                  createKfsDocVal.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {createKfsDoc?.length==index+1 && createKfsDocVal?.status==0 && createKfsDocVal?.try_count==3 &&
                            <button className="btn btn-primary" onClick={() => handleRetryCount(createKfsDocVal?.application_no)}>Retry</button>
                            }
                          </td>
                        </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </FormAccordion>
          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Update Finance"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CIF</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Pennant Message ID</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {updateFinance && (
                    <tbody>
                      {updateFinance.map((data, idx) => (
                        <tr key={idx}>
                          <td>{data.cif}</td>
                          <td>
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => handleResponse(data)}
                            >
                              <u>Request / Response</u>
                            </a>
                          </td>
                          <td>{getUpdateFinanceMsg(data?.response)}</td>
                          {/* <td>{data.try_count}</td> */}
                          <td>{data.http_status_code}</td>
                          <td>
                            {changeStatusText(data.status, data.try_count)}
                          </td>
                          <td>{data.process_message_id}</td>
                          <td>
                            {data.created_at
                              ? dateParser(
                                  data.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.created_at
                              ? dateParser(
                                  data.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {data.updated_at
                              ? dateParser(
                                  data.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.updated_at
                              ? dateParser(
                                  data.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>          

          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Create Mandate"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CIF</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>API Count</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Pennant Message ID</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {createMandate && (
                    <tbody>
                      <tr>
                        <td>{createMandate.cif}</td>
                        <td>
                          <a
                            style={{ cursor: "pointer" }}
                            className="anchorNew"
                            onClick={() => handleResponse(createMandate)}
                          >
                            <u>Request / Response</u>
                          </a>
                        </td>
                        <td>{getPennantMsg(createMandate?.response)}</td>
                        <td>{createMandate.try_count}</td>
                        <td>{createMandate.http_status_code}</td>
                        <td>
                          {changeStatusText(
                            createMandate.status,
                            createMandate.try_count
                          )}
                        </td>
                        <td>{createMandate.process_message_id}</td>
                        <td>{createMandate.message_id}</td>
                        <td>
                          {createMandate.pushed_to_queue_time
                            ? dateParser(
                                createMandate.pushed_to_queue_time,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {createMandate.pushed_to_queue_time
                            ? dateParser(
                                createMandate.pushed_to_queue_time,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {createMandate.created_at
                            ? dateParser(
                                createMandate.created_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {createMandate.created_at
                            ? dateParser(
                                createMandate.created_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {createMandate.updated_at
                            ? dateParser(
                                createMandate.updated_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {createMandate.updated_at
                            ? dateParser(
                                createMandate.updated_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
          {/* <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Update Mandate"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CIF</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>API Count</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Pennant Message ID</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {updateMandate && updateMandate.map((updateDataVal) =>  (
                        <tr>
                          <td>{updateDataVal.cif}</td>
                          <td>
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => handleResponse(updateDataVal)}
                            >
                              <u>Request / Response</u>
                            </a>
                          </td>
                          <td>{getPennantMsg(updateDataVal?.response)}</td>
                          <td>{updateDataVal.try_count}</td>
                          <td>{updateDataVal.http_status_code}</td>
                          <td>
                            {changeStatusText(
                              updateDataVal.status,
                              updateDataVal.try_count
                            )}
                          </td>
                          <td>{updateDataVal.process_message_id}</td>
                          <td>{updateDataVal.message_id}</td>
                          <td>
                            {updateDataVal.pushed_to_queue_time
                              ? dateParser(
                                  updateDataVal.pushed_to_queue_time,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {updateDataVal.pushed_to_queue_time
                              ? dateParser(
                                  updateDataVal.pushed_to_queue_time,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {updateDataVal.created_at
                              ? dateParser(
                                  updateDataVal.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {updateDataVal.created_at
                              ? dateParser(
                                  updateDataVal.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {updateDataVal.updated_at
                              ? dateParser(
                                  updateDataVal.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {updateDataVal.updated_at
                              ? dateParser(
                                  updateDataVal.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                        </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </FormAccordion> */}
          <FormAccordion
            activeTab={activeTab}
            collapse={true}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Add VAS"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CIF</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>HTTP Status Code</th>
                      <th>API Count</th>
                      <th>Applicant type</th>
                      <th>Status</th>
                      <th>Pennant Message ID</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {addVasData && (
                    <tbody>
                      <tr>
                        <td>{addVasData.cif}</td>
                        <td>
                          <a
                            style={{ cursor: "pointer" }}
                            className="anchorNew"
                            onClick={() => handleResponse(addVasData)}
                          >
                            <u>Request / Response</u>
                          </a>
                        </td>
                        <td>{getPennantMsg(addVasData?.response)}</td>
                        <td>{addVasData.http_status_code}</td>
                        <td>{addVasData.try_count}</td>
                        <td>{addVasData.applicant_type}</td>
                        <td>
                          {changeStatusText(
                            addVasData.status,
                            addVasData.try_count
                          )}
                        </td>
                        <td>{addVasData.process_message_id}</td>
                        <td>{addVasData.message_id}</td>
                        <td>
                          {addVasData.pushed_to_queue_time
                            ? dateParser(
                                addVasData.pushed_to_queue_time,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {addVasData.pushed_to_queue_time
                            ? dateParser(
                                addVasData.pushed_to_queue_time,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {addVasData.created_at
                            ? dateParser(
                                addVasData.created_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {addVasData.created_at
                            ? dateParser(
                                addVasData.created_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {addVasData.updated_at
                            ? dateParser(
                                addVasData.updated_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {addVasData.updated_at
                            ? dateParser(
                                addVasData.updated_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
          <FormAccordion
            activeTab={activeTab}
            collapse={true}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Disbursement"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CIF</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>HTTP Status Code</th>
                      <th>API Count</th>
                      <th>Applicant type</th>
                      <th>Status</th>
                      <th>Pennant Message ID</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {disbursementData && (
                    <tbody>
                      <tr>
                        <td>{disbursementData.cif}</td>
                        <td>
                          <a
                            style={{ cursor: "pointer" }}
                            className="anchorNew"
                            onClick={() => handleResponse(disbursementData)}
                          >
                            <u>Request / Response</u>
                          </a>
                        </td>
                        <td>{getPennantMsg(disbursementData?.response)}</td>
                        <td>{disbursementData.http_status_code}</td>
                        <td>{disbursementData.try_count}</td>
                        <td>{disbursementData.applicant_type}</td>
                        <td>
                          {changeStatusText(
                            disbursementData.status,
                            disbursementData.try_count
                          )}
                        </td>
                        <td>{disbursementData.process_message_id}</td>
                        <td>{disbursementData.message_id}</td>
                        <td>
                          {disbursementData.pushed_to_queue_time
                            ? dateParser(
                                disbursementData.pushed_to_queue_time,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {disbursementData.pushed_to_queue_time
                            ? dateParser(
                                disbursementData.pushed_to_queue_time,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {disbursementData.created_at
                            ? dateParser(
                                disbursementData.created_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {disbursementData.created_at
                            ? dateParser(
                                disbursementData.created_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {disbursementData.updated_at
                            ? dateParser(
                                disbursementData.updated_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {disbursementData.updated_at
                            ? dateParser(
                                disbursementData.updated_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
          <FormAccordion
            activeTab={activeTab}
            collapse={true}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Approve Loan"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CIF</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>HTTP Status Code</th>
                      <th>API Count</th>
                      <th>Applicant type</th>
                      <th>Status</th>
                      <th>Pennant Message ID</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {approveLoanData && (
                    <tbody>
                      <tr>
                        <td>{approveLoanData.cif}</td>
                        <td>
                          <a
                            style={{ cursor: "pointer" }}
                            className="anchorNew"
                            onClick={() => handleResponse(approveLoanData)}
                          >
                            <u>Request / Response</u>
                          </a>
                        </td>
                        <td>{getPennantMsg2(approveLoanData?.response)}</td>
                        <td>{approveLoanData.http_status_code}</td>
                        <td>{approveLoanData.try_count}</td>
                        <td>{approveLoanData.applicant_type}</td>
                        <td>
                          {changeStatusText(
                            approveLoanData.status,
                            approveLoanData.try_count
                          )}
                        </td>
                        <td>{approveLoanData.process_message_id}</td>
                        <td>
                          {approveLoanData.created_at
                            ? dateParser(
                                approveLoanData.created_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {approveLoanData.created_at
                            ? dateParser(
                                approveLoanData.created_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {approveLoanData.updated_at
                            ? dateParser(
                                approveLoanData.updated_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {approveLoanData.updated_at
                            ? dateParser(
                              approveLoanData.updated_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>

          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Approve Mandate"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>CIF</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>API Count</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Pennant Message ID</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {approveMandate && approveMandate.map((approveMandatedata) => ( 
                      <tr>
                        <td>{approveMandatedata.cif}</td>
                        <td>
                          <a
                            style={{ cursor: "pointer" }}
                            className="anchorNew"
                            onClick={() => handleResponse(approveMandatedata)}
                          >
                            <u>Request / Response</u>
                          </a>
                        </td>
                        <td>{getPennantMsg(approveMandatedata?.response)}</td>
                        <td>{approveMandatedata.try_count}</td>
                        <td>{approveMandatedata.http_status_code}</td>
                        <td>
                          {changeStatusText(
                            approveMandatedata.status,
                            approveMandatedata.try_count
                          )}
                        </td>
                        <td>{approveMandatedata.process_message_id}</td>
                        <td>{approveMandatedata.message_id}</td>
                        <td>
                          {approveMandatedata.pushed_to_queue_time
                            ? dateParser(
                                approveMandatedata.pushed_to_queue_time,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {approveMandatedata.pushed_to_queue_time
                            ? dateParser(
                                approveMandatedata.pushed_to_queue_time,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {approveMandatedata.created_at
                            ? dateParser(
                                approveMandatedata.created_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {approveMandatedata.created_at
                            ? dateParser(
                                approveMandatedata.created_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {approveMandatedata.updated_at
                            ? dateParser(
                                approveMandatedata.updated_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {approveMandatedata.updated_at
                            ? dateParser(
                                approveMandatedata.updated_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </FormAccordion>
        </>
      );
    } else if (type === "documents") {
      return (
        <>
          <FormAccordion
            activeTab={activeTab}
            collapse={false}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={"Documents"}
            historybtn={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Applicant Name</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>Applicant PAN</th>
                      <th>Document Code</th>
                      <th>DMS UUID</th>
                      <th>Process Instance Id </th>
                      <th>Is Signed</th>
                      <th>Download</th>
                      <th>HTTP Status Code</th>
                      <th>Queue Id</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {docDetails && (
                    <tbody>
                      {docDetails.map((data, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{data?.applicant_name}</td>
                          <td>
                            {data?.request === null &&
                            data?.response === null ? (
                              <span
                                style={{ cursor: "pointer" }}
                                className="anchorNew"
                              >
                                null
                              </span>
                            ) : (
                              <span
                                style={{ cursor: "pointer" }}
                                className="anchorNew"
                                onClick={() => handleDocumentResponse(data)}
                              >
                                <u>Request / Response</u>
                              </span>
                            )}
                          </td>
                          <td>{getDocumentMsg(data?.response)}</td>
                          <td>{data?.applicant_pan}</td>
                          <td>{data?.document_code}</td>
                          <td>{data?.dms_id}</td>
                          <td>{data?.processInstanceId}</td>
                          <td>{data?.is_signed?.toString()}</td>
                          <td>
                            {data?.s3_url ? (
                              <a href={data?.s3_url}>
                                <img src={Images?.download} width={15} />
                              </a>
                            ) : (
                              "NA"
                            )}
                          </td>
                          <td>{data?.http_status_code}</td>
                          <td>{data?.message_id}</td>
                          <td>
                            {data?.queue_pushed_time
                              ? dateParser(
                                  data?.queue_pushed_time,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data?.queue_pushed_time
                              ? dateParser(
                                  data?.queue_pushed_time,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {data.created_at
                              ? dateParser(
                                  data.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.created_at
                              ? dateParser(
                                  data.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {data.updated_at
                              ? dateParser(
                                  data.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.updated_at
                              ? dateParser(
                                  data.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
        </>
      );
    } else if (type === "thirdparty") {
      return (
        <>
          {inputSearch()}
          <FormSection
          >
            <div className="panel-card-table">
              <div className="main-container">
                <table id="employee" className="table table-bordered">
                  <thead>
                    <tr>{renderHeader()}</tr>
                  </thead>
                  <tbody>
                    {filteredTpDetails &&
                      filteredTpDetails.map((item, index) => {
                        return (
                          <tr key={index}>
                            {/* {<td>{givenStart+index}</td> } */}
                            <td>
                              {pageNos === 1
                                ? index + 1
                                : (pageNos - 1) * perPageRecord + index + 1}
                            </td>
                            <td style={{ textAlign: "left" }}>
                              {item?.api_name}
                            </td>
                            <td>
                              <a
                                style={{ cursor: "pointer" }}
                                className="anchorNew"
                                onClick={() => handleResponse(item)}
                              >
                                <u>Request / Response</u>
                              </a>
                            </td>
                            <td>{"NA"}</td>
                            <td>
                              {
                                <span
                                  className={
                                    item?.http_status_code === 200
                                      ? "green"
                                      : null
                                  }
                                >
                                  {item?.http_status_code}
                                </span>
                              }
                            </td>

                            <td>
                              {item.created_at
                                ? dateParser(
                                    item.created_at,
                                    `${ConstVar.DATE_FORMAT}`
                                  )
                                : null}
                              <br />
                              {item.created_at
                                ? dateParser(
                                    item.created_at,
                                    `${ConstVar.TIME_FORMAT}`
                                  )
                                : null}
                            </td>
                            <td>
                              {item.updated_at
                                ? dateParser(
                                    item.updated_at,
                                    `${ConstVar.DATE_FORMAT}`
                                  )
                                : null}
                              <br />
                              {item.updated_at
                                ? dateParser(
                                    item.updated_at,
                                    `${ConstVar.TIME_FORMAT}`
                                  )
                                : null}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
            <div style={{ maxWidth: "150px", margin: "0.5rem" }}>
              <DropDownFilter
                optIdKey="records_id"
                optValueKey="records_value"
                optionList={recordsPerPage}
                placeholder="Records Per Page"
                onChange={(event) => {
                  setPerPageRecord(event.target.value);
                  handleRecordsPerPage(event.target.value);
                }}
                value={perPageRecord}
              />
              {/* <DropDownFilter 
                    optionList={recordsPerPage}
                    optIdKey="records_id"
                    optValueKey="records_value"
                    placeholder="Records per Page"
                    value={pageSize}
                    onChange={(e) => {
                      setGivenStart(1);
                      gotoPage(1);
                      setGivenEnd(parseInt(e.target.value));
                      setPageSize(parseInt(e.target.value));
                    }}
                  /> */}
            </div>
          </FormSection>
        </>
      );
    } else if (type === "webhook") {
      return (
        <>
          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={localization.partnerSystem}
            collapse={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Type</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>API Count</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {webHookData && (
                    <tbody>
                      {webHookData.map((data, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{data.type}</td>
                          <td>
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => handleWebhookResponse(data)}
                            >
                              <u>Request / Response</u>
                            </a>
                          </td>
                          <td>{getWebhookMsg(data?.partner_response)}</td>
                          <td>{data.try_count}</td>
                          <td>{data.http_status_code}</td>
                          <td>
                            {changeStatusText(data.status, data.try_count)}
                          </td>
                          <td>{data.message_id}</td>
                          <td>
                            {data.pushed_to_queue_time
                              ? dateParser(
                                  data.pushed_to_queue_time,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.pushed_to_queue_time
                              ? dateParser(
                                  data.pushed_to_queue_time,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {data.createdAt
                              ? dateParser(
                                  data.createdAt,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.createdAt
                              ? dateParser(
                                  data.createdAt,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {data.updatedAt
                              ? dateParser(
                                  data.updatedAt,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.updatedAt
                              ? dateParser(
                                  data.updatedAt,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
        </>
      );
    } else if (type === "inputrequest") {
      return (
        <>
          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={localization.inputRequest}
            collapse={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <pre>{beautify(inputRequest[0]?.loan_data, null, 2, 100)}</pre>
              </div>
            </div>
          </FormAccordion>
        </>
      );
    } else if (type === "UTR") {
      return (
        <>
          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={localization.utr}
            collapse={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>UTR Number</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>HTTP Status Code</th>
                      <th>API Count</th>
                      <th>Status</th>
                      <th>Message Id</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {utrData && (
                    <tbody>
                      <tr key={1}>
                        <td>1</td>
                        <td>{utrData.utr_number}</td>
                        <td>
                          <a
                            style={{ cursor: "pointer" }}
                            className="anchorNew"
                            onClick={() => utrResponse(utrData)}
                          >
                            <u>Request / Response</u>
                          </a>
                        </td>
                        <td>{utrMsg(utrData?.utr_response)}</td>
                        <td>{utrData.utr_httpstatus_code}</td>
                        <td>{utrData.try_count}</td>
                        <td>{notifacationStatus(utrData.status)}</td>
                        <td>{utrData.utr_process_message_id}</td>
                        <td>{utrData.utr_queue_id}</td>
                        <td>
                          {utrData.utr_queue_datetime
                            ? dateParser(
                                utrData.utr_queue_datetime,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {utrData.utr_queue_datetime
                            ? dateParser(
                                utrData.utr_queue_datetime,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {utrData.created_at
                            ? dateParser(
                                utrData.created_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {utrData.created_at
                            ? dateParser(
                                utrData.created_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {utrData.updated_at
                            ? dateParser(
                                utrData.updated_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {utrData.updated_at
                            ? dateParser(
                                utrData.updated_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
        </>
      );
    } else if (type === "Notification") {
      return (
        <>
          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={localization.notification}
            collapse={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Date Time </th>
                      <th>Content</th>
                      <th>Email Id</th>
                      <th>Request / Response</th>
                      <th>HTTP Status Code</th>
                      <th>API Count</th>
                      <th>Status</th>
                      <th>Queue ID</th>
                      <th>Queue Pushed Time</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {notificationData && (
                    <tbody>
                      {notificationData.map((data, idx) => (
                      <tr key={idx}>
                        <td>{idx+1}</td>
                        <td>
                          {data.notification_datetime
                            ? dateParser(
                              data.notification_datetime,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {data.notification_datetime
                            ? dateParser(
                              data.notification_datetime,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          <a
                            style={{ cursor: "pointer" }}
                            className="anchorNew"
                            onClick={() => notifactionContent(data)}
                          >
                            <u>Notification Content</u>
                          </a>
                        </td>
                        <td>{data.notification_email}</td>
                        <td>
                          <a
                            style={{ cursor: "pointer" }}
                            className="anchorNew"
                            onClick={() =>
                              handleNotificationResponse(data)
                            }
                          >
                            <u>Request / Response</u>
                          </a>
                        </td>
                        <td>
                          {data.email_notification_status === 1
                            ? 200
                            : ""}
                        </td>
                        <td>{data.email_notification_try_count}</td>
                        <td>
                          {notifacationShowStatus(
                            data.email_notification_status, data.email_notification_try_count
                          )}
                        </td>
                        <td>{data.notification_queue_id}</td>
                        <td>
                          {data.notification_queue_datetime
                            ? dateParser(
                              data.notification_queue_datetime,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {data.notification_queue_datetime
                            ? dateParser(
                              data.notification_queue_datetime,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {data.created_at
                            ? dateParser(
                              data.created_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {data.created_at
                            ? dateParser(
                              data.created_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>
                          {data.updated_at
                            ? dateParser(
                              data.updated_at,
                                `${ConstVar.DATE_FORMAT}`
                              )
                            : null}
                          <br />
                          {data.updated_at
                            ? dateParser(
                              data.updated_at,
                                `${ConstVar.TIME_FORMAT}`
                              )
                            : null}
                        </td>
                        <td>

                          {data.email_notification_status == 0 && data.email_notification_try_count > 1 && notificationData?.length == 2 &&  (data?.kfs_api_name === "KFS" || data?.kfs_api_name === "loan_Agreement")
                          ? 
                          (
                          <button
                            className="btn btn-primary"
                            onClick={() => resendCallApi(data?.application_no, data?.id, data?.kfs_api_name)}
                          >
                            Resend
                          </button>
                          )
                          : "" }

                            {data.email_notification_status == 0 && data.email_notification_try_count > 1 && notificationData?.length == 1
                          ? 
                          (
                          <button
                            className="btn btn-primary"
                            onClick={() => resendCallApi(data?.application_no, data?.id)}
                          >
                            Resend
                          </button>
                          )
                          : "" }
                        </td>
                      </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
        </>
      );
    } else if (type === "systemDate") {
      return (
        <>
          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={localization.systemDate}
            collapse={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Application Number</th>
                      <th>Request / Response</th>
                      <th>Message</th>
                      <th>HTTP Status Code</th>
                      <th>Status</th>
                      <th>Loan Id</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {systemDate && (
                    <tbody>
                      {systemDate.map((data, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{data.application_no}</td>
                          <td>
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => systemDateReqRes(data)}
                            >
                              <u>Request / Response</u>
                            </a>
                          </td>
                          <td>{getSystemDateMsg(data?.response)}</td>
                          <td>{data.http_status_code}</td>
                          <td>{changeFusionText(data.status)}</td>
                          <td>{data.loan_id}</td>
                          <td>
                            {data.created_at
                              ? dateParser(
                                  data.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.created_at
                              ? dateParser(
                                  data.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {data.updated_at
                              ? dateParser(
                                  data.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {data.updated_at
                              ? dateParser(
                                  data.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
        </>
      );
    } else if (type === "paymentProcess") {
      return (
        <>
          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={localization.paymentProcess}
            collapse={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      {/* <th>Encode Request/Response</th> */}
                      <th>Request / Response</th>
                      <th>Http Status Code</th>
                      <th>Response Url</th>
                      <th>Response Payment Id</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {paymentProcess && (
                    <tbody>
                      {paymentProcess.map((val, idx) => (
                        <tr key={idx}>
                          <td>{idx+1}</td>
                          {/* <td>
                            {" "}
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => encodeReqRes(val)}
                            >
                              <u> Request / Response</u>
                            </a>
                          </td> */}
                          <td>
                            {" "}
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => decodeReqRes(val)}
                            >
                              <u> Request / Response</u>
                            </a>
                          </td>
                          <td>{val.http_status_code}</td>
                          <td>{val.response_url}</td>
                          <td>{val.response_payment_id}</td>
                          <td>{showText(val.status)}</td>
                          <td>
                            {val.created_at
                              ? dateParser(
                                  val.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {val.created_at
                              ? dateParser(
                                  val.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {val.updated_at
                              ? dateParser(
                                  val.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {val.updated_at
                              ? dateParser(
                                  val.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
        </>
      );
    } else if (type === "paymentReceipt") {
      return (
        <>
          <FormAccordion
            activeTab={activeTab}
            handleTabSelection={(e) => {
              handleTabSelection(e);
            }}
            title={localization.paymentReceipt}
            collapse={false}
          >
            <div className="panel-card-table">
              <div className="main-container">
                <Table responsive>
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      {/* <th>Encode Request/Response</th> */}
                      <th>Request / Response</th>
                      <th>Http Status Code</th>
                      <th>Response Payment Id</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th>Updated At</th>
                    </tr>
                  </thead>
                  {paymentReceipt && (
                    <tbody>
                      {paymentReceipt.map((val, idx) => (
                        <tr>
                          <td>{idx+1}</td>
                          {/* <td>
                            {" "}
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => encodeReqRes(val)}
                            >
                              <u> Request / Response</u>
                            </a>
                          </td> */}
                          <td>
                            {" "}
                            <a
                              style={{ cursor: "pointer" }}
                              className="anchorNew"
                              onClick={() => decodeReqRes(val)}
                            >
                              <u> Request / Response</u>
                            </a>
                          </td>
                          <td>{val.http_status_code}</td>
                          <td>{val.response_payment_id}</td>
                          <td>{showText(val.status)}</td>
                          <td>
                            {val.created_at
                              ? dateParser(
                                  val.created_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {val.created_at
                              ? dateParser(
                                  val.created_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                          <td>
                            {val.updated_at
                              ? dateParser(
                                  val.updated_at,
                                  `${ConstVar.DATE_FORMAT}`
                                )
                              : null}
                            <br />
                            {val.updated_at
                              ? dateParser(
                                  val.updated_at,
                                  `${ConstVar.TIME_FORMAT}`
                                )
                              : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          </FormAccordion>
        </>
      );
    }
  };
  const notifacationStatus = (data) => {
    let statusName;
    if (data == 0) {
      statusName = "Failed";
    } else if (data == 1) {
      statusName = "Approved";
    }
    return statusName;
  };

  const notifacationShowStatus = (notificationStatus, notificationTryCount) => {
    let statusName;
    if (notificationStatus == 0 && notificationTryCount > 1) {
      statusName = "Failed";
    } else if (notificationStatus == 1) {
      statusName = "Completed";
    }
    return statusName;
  }

  const handleResponse = (createLead) => {

    //substring function -1;
    setModalShow(true);
    if (createLead?.request) {
      const req = trim( typeof createLead?.request === "object"
      ? JSON.stringify(createLead?.request)
      : createLead?.request);
      setRequest(req);
    }
    if (createLead?.response) {
      const res = trim(
        typeof createLead?.response === "object"
          ? JSON.stringify(createLead?.response)
          : createLead?.response
      );
      setResponse(res);
    }
  };

  const handleDocumentResponse = (data) => {
    setModalShow(true);
    if (data?.request) {
      const req = JSON.parse(JSON.stringify(data?.request));
      setRequest(JSON.stringify(req));
    }
    if (data?.response) {
      const res = JSON.parse(JSON.stringify(data?.response));
      setResponse(JSON.stringify(res));
    }
  };

  const handleWebhookResponse = (webhookData, check = false) => {
    const webData = webhookData;
    setModalShow(true);
    if (check) {
      if (webData?.bre_request) {
        setRequest(webData?.bre_request);
      }
      if (webData?.bre_response) {
        setResponse(webData?.bre_response);
      }
    } else {
      if (webData?.partner_request) {
        setRequest(JSON.stringify(webData?.partner_request));
      }
      if (webData?.partner_response) {
        setResponse(JSON.stringify(webData?.partner_response));
      }
    }
  };

  const systemDateReqRes = (data) => {
    setModalShow(true);
    if (data?.request) {
      const req = trim(
        typeof data?.request === "object"
          ? JSON.stringify(data?.request)
          : data?.request
      );
      setRequest(req);
    }
    if (data?.response) {
      const res = trim(
        typeof data?.response === "object"
          ? JSON.stringify(data?.response)
          : data?.response
      );
      setResponse(res);
    }
  };

  const handleNotificationResponse = (data) => {
    setModalShow(true);
    if (data?.email_request) {
      const req = trim(
        typeof data?.email_request === "object"
          ? JSON.stringify(data?.email_request)
          : data?.email_request
      );
      setRequest(req);
    }
    if (data?.email_response) {
      const res = trim(
        typeof data?.email_response === "object"
          ? JSON.stringify(data?.email_response)
          : data?.email_response
      );
      setResponse(res);
    }
  };

  const notifactionContent = (data) => {
    setModalShow(true);
    if (data?.notification_content) {
      const req = trim(
        typeof data?.notification_content === "object"
          ? JSON.stringify(data?.notification_content)
          : data?.notification_content
      );
      setRequest(req);
      setResponse("notification");
    }
  };

  const utrResponse = (data) => {
    setModalShow(true);
    if (data?.utr_request) {
      const req = trim(
        typeof data?.utr_request === "object"
          ? JSON.stringify(data?.utr_request)
          : data?.utr_request
      );
      setRequest(req);
    }
    if (data?.utr_response) {
      const res = trim(
        typeof data?.utr_response === "object"
          ? JSON.stringify(data?.utr_response)
          : data?.utr_response
      );
      setResponse(res);
    }
  };

  const closeModal = () => {
    setModalShow(false);
    setResponse("");
    setRequest("");
  };

  return (
    <BaseUrl.Provider value={{ baseUrl: match.url }}>
      <MainLayout
        activeComponent={activeComponent}
        subSideBar={true}
        setSelectedTab={setSelectedTab}
        selectedTab={selectedTab}
        match={match}
        showSide={true}
      >
        <Layout
          title={localization.allApplications}
          subtitle={match?.params?.id}
          isLoading={false}
          isGoback={true}
          className={"desktop-view"}
          gobackFun={true}
        >
          {/* {renderLeadForm()} */}
          {selectedTab == 0 ? renderAllFields("applicant") : null}
          {selectedTab == 1 ? renderAllFields("crm") : null}
          {selectedTab == 2 ? renderAllFields("thirdparty") : null}
          {selectedTab == 3 ? renderAllFields("fusion") : null}
          {selectedTab == 4 ? renderAllFields("webhook") : null}
          {/* {selectedTab == 4 ? <FormAccordion activeTab={activeTab} handleTabSelection={(e)=>{handleTabSelection(e)}} title={localization.partnerSystem} ></FormAccordion> : null} */}
          {selectedTab == 5 ? renderAllFields("pennant") : null}
          {selectedTab == 6 ? renderAllFields("documents") : null}
          {selectedTab == 7 ? renderAllFields("inputrequest") : null}
          {selectedTab == 8 ? renderAllFields("UTR") : null}
          {selectedTab == 9 ? renderAllFields("Notification") : null}
          {/* {selectedTab == 10 ? renderAllFields("systemDate") : null} */}
          {selectedTab == 10 ? renderAllFields("paymentProcess") : null}
          {selectedTab == 11 ? renderAllFields("paymentReceipt") : null}

          {modalShow && (
            <CustomModal
              show={modalShow}
              modalClose={closeModal}
              showHeader
              backdrop
            >
              <div className="modal-body chekdisplay">
                <div
                  className={
                    response !== "notification"
                      ? "panel-card panelcard"
                      : "panel-card notification-w"
                  }
                >
                  <div className="panel-heading pop">
                    {response !== "notification" ? (
                      <>
                        Request
                        <div style={{ float: "right" }}>
                          <CopyPaste data={request} />
                        </div>
                      </>
                    ) : (
                      "Notification Content"
                    )}
                  </div>
                  <div className="panel-body  mx-0 pop ">
                    <div className="panel-card-table">
                      {response !== "notification" ? (
                        <div className="popupclass">
                          {testJSON(
                            request
                              ? request.toString().replace(/\\/g, "")
                              : "null"
                          ) ? (
                            <JsonFormatter
                              json={
                                request
                                  ? request.toString().replace(/\\/g, "")
                                  : "null"
                              }
                              tabWith={4}
                              jsonStyle={jsonStyle}
                            />
                          ) : request ? (
                            request.toString().replace(/\\/g, "")
                          ) : (
                            "null"
                          )}
                        </div>
                      ) : (
                        <pre className="pre-h">
                          {beautify(JSON.parse(request), null, 2, 80)}
                        </pre>
                      )}
                    </div>
                  </div>
                </div>
                {response !== "notification" ? (
                  <div className="panel-card panelcard">
                    <div className="panel-heading pop">
                      Response
                      <div style={{ float: "right" }}>
                        <CopyPaste data={response} />
                      </div>
                    </div>
                    <div className="panel-body mx-0 pop ">
                      <div className="panel-card-table">
                        <div className="popupclass">
                          {testJSON(
                            response
                              ? response.toString().replace(/\\/g, "")
                              : "null"
                          ) ? (
                            <JsonFormatter
                              json={
                                response
                                  ? response.toString().replace(/\\/g, "")
                                  : "null"
                              }
                              tabWith={4}
                              jsonStyle={jsonStyle}
                            />
                          ) : response ? (
                            response.toString().replace(/\\/g, "")
                          ) : (
                            "null"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </CustomModal>
          )}
          <Loader isLoading={isLoading} />
        </Layout>
        <div className="mobile-view container">
          <h3>{localization.label.myLead}</h3>
          <div className="my-lead-wrap"></div>
        </div>
      </MainLayout>
    </BaseUrl.Provider>
  );
};

export default ApplicationDetails;
